<template>
  <div id="add-snap-form">
    <a-spin v-if="isLoading && snapForms.length == 0"></a-spin>
    <div class="snap-form" v-if="snapForms.length > 0">
      <a-form>
        <a-form-item label="Form" :label-col="{ span: 5 }" :wrapperCol="{ span: 13 }">
          <a-select placeholder="Select a form" class="select-snap-form" @change="selectSnapForm">
            <a-select-option v-for="form in snapForms" :key="form.lead_generation_form.id">
              {{ form.lead_generation_form.name }} - {{ form.lead_generation_form.description }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-if="selectedForm !== null">
          <field-mappings :is-production="isProduction"></field-mappings>
        </a-form-item>

        <a-form-item v-if="selectedForm !== null" class="create-button">
          <a-button :loading="isLoading" type="primary" @click="createWebhook()">
            Create Form Mapping
          </a-button>
        </a-form-item>
      </a-form>
    </div>

    <a-button v-else-if="snapForms.length == 0 && code == null && !isLoading" @click="authenticateSnapchat()">
      Connect to Snapchat
    </a-button>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import FieldMappings from "@/components/FieldMappings";

export default {
  components: {
    FieldMappings,
  },
  computed: {
    ...mapState(["apiUrl", "user", "jsonData", "snapForms"]),
  },
  data() {
    return { code: null, authToken: null, selectedForm: null, isLoading: false, isProduction: false };
  },
  methods: {
    authenticateSnapchat() {
      window.location.href = `https://accounts.snapchat.com/login/oauth2/authorize?client_id=${process.env.VUE_APP_SNAP_CLIENT_ID}&redirect_uri=${process.env.VUE_APP_SNAP_REDIRECT_URL}&response_type=code&scope=snapchat-marketing-api`;
    },
    selectSnapForm(id) {
      const form = this.snapForms.find((f) => f.lead_generation_form.id === id);
      if (form != null) {
        const json = this.convertToJson(form.lead_generation_form.form_fields);
        this.$store.commit("setFormData", {
          jsonData: JSON.stringify(json),
          isProduction: false,
          isError: false,
        });

        this.selectedForm = form;
      }
    },

    // Convert the form field array to json.
    // the form_fields format is
    // form_fields: [
    //   {
    //     type: "FIRST_NAME",
    //   },
    //   {
    //     type: "LAST_NAME",
    //   },...]
    // and we're going to transform it to
    // {"FIRST_NAME": "{{FIRST_NAME}}", "LAST_NAME": "{{LAST_NAME}}"}
    convertToJson(fields) {
      return fields.reduce((acc, field) => {
        // Add each type to the accumulator object with the corresponding string value
        acc[field.type] = `{{${field.type}}}`;
        return acc;
      }, {});
    },

    createWebhook() {
      const form = this.selectedForm.lead_generation_form;
      this.isLoading = true;
      axios
        .request({
          method: "post",
          url: `${this.apiUrl}/snap-webhook`,
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
          params: {
            formId: form.id,
          },
          data: {
            name: form.name,
            description: form.description,
            jsonData: this.jsonData,
            isProduction: this.isProduction,
          },
        })
        .then((r) => console.log(r))
        .catch((e) => {
          const err = e.response.data;
          console.error(err);
          console.error(err.display_message);
          alert(err.display_message);
        })
        .finally(() => {
          this.isLoading = false;
           this.$router.back();
        });
    },
  },
  // 1. First check if snap is already authenticated by checking in the store.
  // 2. If it's not in the store, let's get the forms from the backend and save it to store.
  //    (If it was consented before, and the auth token expired, automatically refresh it in the backend)
  // 3. It there was no record in the db yet for snapchat, go ahead and ask the user for consent
  mounted() {
    this.isLoading = true;
    // 1.
    console.log("on mount", this.snapForms.length);
    if (this.snapForms.length == 0) {
      axios
        .request({
          method: "get",
          url: `${this.apiUrl}/snap-forms`,
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
        })
        .then((r) => {
          console.log(r);
          if (r.status == 200) {
            const {forms, existingFormIds} =r.data
            const unsubscribedForms = forms.filter((f) => !existingFormIds.includes(f.lead_generation_form.id))
            console.log(existingFormIds);
            console.log(unsubscribedForms)
            this.$store.commit("setSnapForms", unsubscribedForms);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
    this.code = this.$route.query.code;

    if (this.code != null) {
      // get the authorization code
      this.isLoading = true;
      axios
        .request({
          method: "post",
          url: `${this.apiUrl}/snap-auth`,
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
          params: {
            code: this.code,
          },
        })
        .then((r) => {
          console.log(r);
          if (r.status == 200) {
            this.$store.commit("setSnapForms", r.data.forms);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
};
</script>

<style lang="scss" scoped>
#add-snap-form {
  display: flex;
  justify-content: center;
}

.snap-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.select-snap-form {
  width: 100%;
  max-width: 500px;
  align-self: center;
}

.create-button {
  display: flex;
  justify-content: center;
}
</style>
